<template>
  <a-modal
    title="查看退款"
    :maskClosable="false"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    :footer="null"
    @ok="handleCancel"
    @cancel="handleCancel"
  >
    <div class="inner">
      <!-- 退款详情 -->
      <refund-info :refundDetail="refundDetail"></refund-info>

      <!-- 审核 -->
      <div
        class="tab-oper"
        v-if="tabIndex == '0' && refundDetail.status == '1'"
      >
        <a-button @click="tabChange('1')">审核退款</a-button>
        <a-button @click="tabChange('2')">审核驳回</a-button>
      </div>

      <!-- 审核退款 -->
      <div class="tab-content" v-if="tabIndex == '1'">
        <div class="item">
          <div class="key">实际退款总价：</div>
          <div class="value">
            {{
              (coursePrice ? coursePrice : 0) +
              (textbookPrice ? textbookPrice : 0)
            }}
          </div>
          <div class="desc"></div>
        </div>
        <div class="item">
          <div class="key"><span class="must">*</span>课时费退款：</div>
          <div class="value">
            <a-input-number
              v-model="coursePrice"
              :min="0"
              :max="refundDetail.coursePrice / 100"
            ></a-input-number>
            <div class="desc">
              最多退款￥{{ refundDetail.coursePrice | price }}
            </div>
          </div>
        </div>
        <div class="item">
          <div class="key"><span class="must">*</span>教材费退款：</div>
          <div class="value">
            <a-input-number
              v-model="textbookPrice"
              :min="0"
              :max="refundDetail.textbookPrice / 100"
            ></a-input-number>
            <div class="desc">
              最多退款￥{{ refundDetail.textbookPrice | price }}
            </div>
          </div>
        </div>
        <div class="item">
          <div class="key">退款备注：</div>
          <div class="value">
            <a-textarea class="textarea" v-model="remark"></a-textarea>
          </div>
        </div>
      </div>

      <!-- 审核驳回 -->
      <div class="tab-content" v-if="tabIndex == '2'">
        <div class="item">
          <div class="key"><span class="must">*</span>驳回原因：</div>
          <div class="value">
            <a-textarea class="textarea" v-model="remark"></a-textarea>
          </div>
        </div>
      </div>

      <!-- 提及/取消审核 -->
      <div class="tab-oper" v-if="tabIndex != '0'">
        <a-button type="primary" @click="submitCheck">确定</a-button>
        <a-button @click="cancelCheck">取消</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import refund from "../../../api/refund";

import RefundInfo from "./RefundInfo";

export default {
  name: "refundFormModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      refundDetail: {}, //展示退款详情的容器
      tabIndex: "0", //审核操作选择按钮
      textbookPrice: null, //教材费价格
      coursePrice: null, //课时费价格
      remark: "", //退款备注
      id: "",
    };
  },
  components: {
    RefundInfo,
  },
  methods: {
    tabChange(val) {
      this.tabIndex = val;
    },

    //取消审核
    cancelCheck() {
      this.tabIndex = "0";
    },

    //校验
    formCheck() {
      let res = true;
      if (this.tabIndex == "1") {
        if (!this.coursePrice && this.coursePrice != 0) {
          this.$message.warn("请输入课时费价格");
          res = false;
        } else if (!this.textbookPrice && this.textbookPrice != 0) {
          this.$message.warn("请输入教材费价格");
          res = false;
        }
      } else {
        if (!this.remark) {
          this.$message.warn("请输入驳回原因");
          res = false;
        }
      }
      return res;
    },

    //提交审核
    submitCheck() {
      if (this.formCheck()) {
        let req = {
          id: this.refundDetail.id,
          status: this.tabIndex == "1" ? "2" : "3", //2成功，3失败
          refundFee: ((this.coursePrice + this.textbookPrice) * 100).toFixed(0), //退款金额 = 课时费退款金额 + 教材费退款金额
          refundCourseFee: this.coursePrice * 100, //课时费退款金额
          refundTextbookFee: this.textbookPrice * 100, //教材费退款金额
          remark: this.remark, //退款备注
        };
        if (this.tabIndex == "2") {
          delete req.refundFee;
          delete req.refundCourseFee;
          delete req.refundTextbookFee;
        }
        refund.checkRefund(req).then((res) => {
          this.cancelCheck();
          this.$message.success("审核成功");
          this.getRefundDetail();
        });
      }
    },

    //数据初始化
    initData() {
      this.tabIndex = "0"; //审核操作选择按钮
      this.textbookPrice = null; //教材费价格
      this.coursePrice = null; //课时费价格
      this.remark = ""; //退款备注
    },

    //初始化，显示
    init(params) {
      this.visible = true;
      //初始化form表单数据
      if (params) {
        this.id = params.id;
        this.initData();
        this.getRefundDetail();
      }
    },

    //获取退款详情
    getRefundDetail() {
      refund.get(this.id).then((res) => {
        console.log(res);
        this.refundDetail = res.data;
        this.textbookPrice = res.data.applyRefundTextbookFee
          ? res.data.applyRefundTextbookFee / 100
          : null;
        this.coursePrice = res.data.applyRefundCourseFee
          ? res.data.applyRefundCourseFee / 100
          : null;
      });
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.inner {
  padding: 0px 30px;
  max-height: calc(100vh - 300px);
  overflow: auto;
}

.tab-oper {
  text-align: center;
  margin-top: 20px;
  > button {
    margin-right: 10px;
  }
}
.tab-content {
  margin-top: 20px;
  > .item {
    line-height: 30px;
    padding: 10px 0px;
    > .key {
      display: inline-block;
      width: 120px;
      text-align: right;
      vertical-align: top;
      > .must {
        color: red;
      }
    }
    > .value {
      display: inline-block;
      width: calc(100% - 120px);
      > .desc {
        display: inline-block;
        color: $normal-color-dark;
        margin-left: 6px;
      }
      > .textarea {
        height: 100px;
      }
    }
  }
}
</style>